import { Component, Input, OnInit } from '@angular/core';

import { PortalProveedorService, SupplierExtendedData } from '../../../../services/api.services';
import { OperatorFront } from '../../../../models/api.models';


@Component({
  selector: 'app-selector-operario',
  templateUrl: './selector-operario.component.html',
  styleUrls: ['./selector-operario.component.scss'],
})
export class SelectorOperarioComponent implements OnInit {

  @Input() operarios: OperatorFront[];
  @Input() isModal;
  @Input() afterLogin;
  showMultiOperatorFilter = true;
  operatorId: number;

  constructor(private portalProveedorService: PortalProveedorService) { }

  ngOnInit() {

    this.portalProveedorService.getSupplierDataCached().subscribe((supplierExtendedData: SupplierExtendedData) => {
      if (supplierExtendedData.supplier.house_supplier_view_permissions.must_select_operator) {
        this.showMultiOperatorFilter = false;
      } else {
        this.showMultiOperatorFilter = true;
      }

    });
    const operatorIdSelected = this.portalProveedorService.getOperatorSel();
    this.selectOperator(operatorIdSelected);
  }

  private selectOperator  = (id: number) => {
    if (id) {
      this.operatorId = id;
    } else {
      this.operatorId = -2;
    }
  }

  operatorSelected(event) {
    if (event.detail.value === -2) {
      this.portalProveedorService.setOperatorSel(null);
    } else {
      this.portalProveedorService.setOperatorSel(event.detail.value);
    }
    this.portalProveedorService.selectOperatorEvent.emit(this.portalProveedorService.getOperatorSel());
  }
}
